import type { PageV1 } from './models.ts';

export const initialPageV1: PageV1<never> = {
  content: [],
  first: false,
  last: false,
  number: 0,
  numberOfElements: 0,
  size: 0,
  totalElements: 0,
  totalPages: 0
};
